var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    { attrs: { loading: _vm.isLoading, hasData: !_vm.isLoading } },
    [
      _vm.isDataLoaded
        ? _c(
            "AuthCard",
            { attrs: { title: _vm.authCardTitle, width: "wide" } },
            [
              _c("PricePlanProvider", {
                staticClass: "-mt-4 mx-3 flex-shrink-0",
                attrs: {
                  subscriptionDetails: _vm.subscriptionPlan,
                  innerName: _vm.innerSubscriptionName,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ slogan, title, price }) {
                        return [
                          _c("PriceCardViewTitle", {
                            staticClass: "mb-2",
                            attrs: {
                              slogan: slogan,
                              title: title,
                              isTrial: _vm.isTrial,
                              withoutMinHeight: "",
                            },
                          }),
                          _c("PriceCardViewPricing", {
                            attrs: {
                              price: price,
                              managersCount: _vm.managersCount,
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1618872268
                ),
              }),
              _c("p", { staticClass: "text-center mb-4" }, [
                _vm._v(
                  "Linking your credit card now is optional but recommended for uninterrupted service post-trial."
                ),
              ]),
              _vm.inactiveSubscriptionsExist
                ? _c("UpdateSubscriptionOptions", {
                    staticClass: "mb-5",
                    attrs: {
                      currentUserId: _vm.currentUser.id,
                      paymentCards: _vm.paymentCards,
                      chosenSubscriptionPlanId: _vm.subscriptionPlanId,
                      isPaymentCardsExist: _vm.isPaymentCardsExist,
                      cardFormTitle: _vm.cardFormTitle,
                      cardsListTitle: _vm.cardsListTitle,
                    },
                    on: {
                      subscriptionUpdated: _vm.onCompleteSubscriptionAction,
                    },
                  })
                : _c("CreateSubscriptionOptions", {
                    staticClass: "mb-7",
                    attrs: {
                      currentUserId: _vm.currentUser.id,
                      paymentCards: _vm.paymentCards,
                      isPaymentCardsExist: _vm.isPaymentCardsExist,
                      chosenSubscriptionPlanId: _vm.subscriptionPlanId,
                      cardFormTitle: _vm.cardFormTitle,
                      cardsListTitle: _vm.cardsListTitle,
                    },
                    on: {
                      subscriptionCreated: _vm.onCompleteSubscriptionAction,
                    },
                  }),
              _c(
                "div",
                { staticClass: "flex justify-center items-center mb-4" },
                [
                  _vm.firstSubscription
                    ? _c(
                        "button",
                        {
                          staticClass: "text-badgeBlue text-base font-normal",
                          attrs: { type: "button" },
                          on: { click: _vm.subscribeWithoutCard },
                        },
                        [_vm._v("Add later")]
                      )
                    : _vm._e(),
                ]
              ),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "flex justify-center items-center flex-col" },
                  [
                    _c("p", [
                      _vm._v(
                        "Need to adjust later? You can add more manager seats at any time."
                      ),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass:
                          "text-badgeBlue text-base font-normal mt-2",
                        attrs: { type: "button" },
                        on: { click: _vm.subscribeWithoutCard },
                      },
                      [_vm._v("Go to Talent Directory ")]
                    ),
                  ]
                ),
              ]),
              !!_vm.errorMessage
                ? _c("FormError", {
                    staticClass: "flex justify-center",
                    attrs: { errorMessage: _vm.errorMessage },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }